import {ApiCollectionResponse, GetCollectionQueryParams} from '../../types';
import {ReadLead} from '@tinct/core-api-models';
import {ApiError, tinctApi} from '../../api';
import {useQuery, UseQueryOptions} from '@tanstack/react-query';
import {GetAudienceLeadsStaticFilter} from '../../endpoints/audiences';

type GetAudienceLeadsQueryParams = {
  term?: string;
}

export type GetAudienceLeadsParams = GetCollectionQueryParams<ReadLead, GetAudienceLeadsStaticFilter> & {
  filters?: GetAudienceLeadsQueryParams
}

export const getAudienceLeads = async (
  params: GetAudienceLeadsParams,
): Promise<ApiCollectionResponse<ReadLead>> => {
  return await tinctApi.audiences.getAudienceLeads(params);
};

export const useGetAudienceLeads = (
  params: GetAudienceLeadsParams,
  options?: Omit<
    UseQueryOptions<ApiCollectionResponse<ReadLead>, ApiError>,
    'queryKey'
  >,
) =>
  useQuery({
    queryKey: ['audiences', params.staticParams?.audienceId, 'leads', params],
    queryFn: () => getAudienceLeads(params),
    ...options,
  });
